import PosthogService from '~/services/posthog/PosthogService';
import { type TNotificationChannel } from '~/domain/NotificationSettings';

export interface INotificationToggledPayload {
  /** Server event name, e.g. `OFFICE_EVENT_OFFER_RECEIVED`. */
  eventType: string;
  /** Human-readable notification title as shown on the page. */
  notificationType: string;
  /** Collapsible section the notification sits under, e.g. `Offer Activity`. */
  section: string;
  channel: TNotificationChannel;
  isEnabled: boolean;
}

/**
 * Fires when an office flips a single channel switch. Note this is intent, not
 * configuration — the change is only persisted once Save succeeds, so pair this
 * with `settings_completed` rather than reading it as the office's state.
 */
export function fireNotificationToggled({
  eventType,
  notificationType,
  section,
  channel,
  isEnabled,
}: INotificationToggledPayload): void {
  PosthogService.getInstance().track('dental_portal:notification_settings:notification_toggled', {
    event_type: eventType,
    notification_type: notificationType,
    section,
    channel,
    is_enabled: isEnabled,
  });
}
